<div class="dialog-header">
  <h1 mat-dialog-title>
    <span><ng-container i18n>Recommendation Notifications</ng-container></span>
  </h1>
</div>

<div class="steps-container">
  <p-steps
    styleClass="notification-welcome-stepper"
    [model]="stepItems"
    [readonly]="false"
    [activeIndex]="activeIndex"></p-steps>
</div>

<mat-dialog-content>
  @if (activeIndex === 0) {
    <ul>
      <li>
        <ng-container i18n
          >We have added a new self-managed Recommendation Notification tool,
          where users can create rules to receive e-mail or text notifications
          related to Recommendation updates.</ng-container
        >
      </li>
      <li>
        <ng-container i18n
          >This is managed in the User Profile Settings user Accounts, available
          in the upper-right menu of the dashboard.</ng-container
        >
      </li>
      <li>
        <ng-container i18n
          >On the next page are basic rules you can choose to adopt, or you can
          use the below link to go to the User Profile Notification
          section.</ng-container
        >
      </li>
    </ul>
    <div
      class="link-section"
      [routerLink]="['/account/notifications']"
      (click)="dialogRef.close()">
      <a><ng-container i18n>Navigate to User Settings</ng-container></a>
      <i class="pi pi-arrow-right"></i>
    </div>
  }

  @if (activeIndex === 1) {
    <ul>
      <li>
        <ng-container i18n
          >Select which Notifications you would like to receive. This will apply
          to all of your Sites for the Company.</ng-container
        >
      </li>
      <li>
        <ng-container i18n
          >If you want to customize your Sites, this can be found on the User
          Accounts page.</ng-container
        >
      </li>
      <li>
        <ng-container i18n
          >If you need further assistance, please contact your CME or CSM, or
          obtain assistance on your Cadence Call.</ng-container
        >
      </li>
    </ul>
    <div class="checkbox-container">
      <p class="checkbox-header">
        <ng-container i18n
          >Receive Notifications for the below conditions:</ng-container
        >
      </p>
      <div class="checkbox-group">
        <p-checkbox
          [(ngModel)]="all"
          [binary]="true"
          (onChange)="
            notificationForm.updateValueAndValidity(); allSelected()
          "></p-checkbox>
        <label for="all"
          ><ng-container i18n
            >All Events for a Recommendation</ng-container
          ></label
        >
      </div>
      <div class="checkbox-group">
        <p-checkbox
          [(ngModel)]="closed"
          [binary]="true"
          [disabled]="all"
          (onChange)="notificationForm.updateValueAndValidity()"></p-checkbox>
        <label for="closed"><ng-container i18n>Closed</ng-container></label>
      </div>
      <div class="checkbox-group">
        <p-checkbox
          [(ngModel)]="created"
          [binary]="true"
          [disabled]="all"
          (onChange)="notificationForm.updateValueAndValidity()"></p-checkbox>
        <label for="created"><ng-container i18n>Created</ng-container></label>
      </div>
    </div>
    <form [formGroup]="notificationForm" class="inputs uppercase dialog-form">
      <div formGroupName="notificationType" class="p-field notification-type">
        <label for="notificationType"
          ><ng-container i18n>Notification Type</ng-container></label
        >
        <div class="notification-switches">
          <div class="toggle">
            <span class="title uppercase">SMS</span>
            <mat-slide-toggle
              formControlName="sms"
              (change)="smsChanged()"></mat-slide-toggle>
          </div>
          <div class="toggle">
            <span class="title uppercase">Email</span>
            <mat-slide-toggle formControlName="email"></mat-slide-toggle>
          </div>
        </div>
      </div>
      <div
        [style]="{
          visibility:
            (!(userInfoService.info$ | async)!.phone?.length ||
              !(userInfoService.info$ | async)?.smsConsent) &&
            notificationForm.get('notificationType')?.get('sms')?.value
              ? undefined
              : 'hidden',
          position: 'relative',
          width: '50%',
          height:
            (!(userInfoService.info$ | async)!.phone?.length ||
              !(userInfoService.info$ | async)?.smsConsent) &&
            notificationForm.get('notificationType')?.get('sms')?.value
              ? '11rem'
              : 0,
          overflow: 'auto'
        }">
        <div
          class="p-field notification-type"
          style="display: flex; flex-direction: column">
          <label for="phone-number" style="margin-bottom: 0.5rem" i18n
            >Phone number</label
          >
          <mat-form-field appearance="outline">
            <input
              id="phone-number"
              formControlName="phoneNumber"
              class="uppercase"
              type="tel"
              matInput
              numbersOnly
              (ngModelChange)="resetPhoneErrors()" />
            @if (
              notificationForm.get('phoneNumber')?.getError('twilioValidation');
              as message
            ) {
              <mat-error class="error">
                {{ message }}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="notification-consent">
          <div>
            <mat-checkbox formControlName="smsConsent"></mat-checkbox>
            <label
              ><ng-container i18n
                >Consent to receive SMS messages</ng-container
              ></label
            >
          </div>
          <p>
            <ng-container i18n
              >By enabling SMS notifications, I agree to receive recurring
              messages from Advanced Technology Services, Inc. (ATS) to the
              provided mobile number and also agree to the ATS terms and
            </ng-container>
            <a
              href="https://www.advancedtech.com/privacy-policy/"
              target="_blank">
              <ng-container i18n>privacy policy</ng-container> </a
            >.
            <ng-container i18n>Message & data rates may apply</ng-container>
          </p>
        </div>
      </div>
    </form>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <section class="buttons">
    @if (activeIndex === 0) {
      <button class="cancel-button" (click)="dialogRef.close()">
        <ng-container i18n>Cancel</ng-container>
      </button>
    }
    @if (activeIndex === 1) {
      <button class="cancel-button" (click)="activeIndex = 0">
        <ng-container i18n>Back</ng-container>
      </button>
    }
    @if (activeIndex === 0) {
      <button class="save-button" (click)="activeIndex = 1">
        <ng-container i18n>Next</ng-container>
      </button>
    }
    @if (activeIndex === 1) {
      <button
        class="save-button"
        [disabled]="awaitingResponse || !notificationForm.valid"
        [title]="
          notificationForm?.value?.notificationType?.sms &&
            notificationForm?.value?.phoneNumber &&
            !notificationForm?.value?.smsConsent | welcomeTooltip
        "
        (click)="save()">
        <ng-container i18n>Save</ng-container>
      </button>
    }
  </section>
  <section style="margin-top: 1rem">
    @if (activeIndex === 0) {
      <button
        class="cancel-button do-not-show-again"
        style="margin-left: auto"
        (click)="doNotShowAgain()">
        <ng-container i18n>Don't Show This Again</ng-container>
      </button>
    }
  </section>
</mat-dialog-actions>
